export default "__VITE_ASSET__BzzzOOM7__"